module.exports = __webpack_public_path__ + "img/40_69_002_330.2a754a4f.jpg";